import React from 'react'

interface FooterCopyrightProps {
  /**
   * compact — single quiet line for auth screens and tight footers.
   * full — legal footer line for landing/terms/privacy pages.
   */
  variant?: 'compact' | 'full'
  className?: string
}

/**
 * The one source of truth for the Sthirvana copyright line.
 * Treu is a product of Sthirvana; the copyright holder is Sthirvana.
 */
export const FooterCopyright: React.FC<FooterCopyrightProps> = ({ variant = 'full', className = '' }) => {
  const year = new Date().getFullYear()

  if (variant === 'compact') {
    return (
      <div className={`text-center text-xs ${className}`}>
        Treu is a Sthirvana product · © {year} Sthirvana
      </div>
    )
  }

  return (
    <div className={`text-center text-sm ${className}`}>
      © {year} Sthirvana. All rights reserved. Treu is a Sthirvana product.
    </div>
  )
}

export default FooterCopyright
